import { get, post } from "../http/platformServer";

export interface PreShippingSetting {
    shopId: number;
    /**启动设置 */
    enabled: boolean;
    /**是否开启有物流自动发货 */
    enableAutoShippingByTracking: boolean;
    /**同意免责声明 */
    enableScheduledShipping: boolean;

    scheduledShippingTime?: string;
}

export function getPreShippingSetting(shopId: number) {
    return get<PreShippingSetting>(shopId, "/pre_shipping/get", {
        shopId,
    });
}

export function savePreShippingSetting(params: PreShippingSetting) {
    return post<PreShippingSetting>(params.shopId, "/pre_shipping/save", params);
}
